export default {"src":"/_next/static/media/HelpLight.ac8497ae.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};